const HUNTING_BOW = {
  slug: "hunting-bow",
  name: "Hunting Bow",
  description: "Used to take down big game",
  rarity: "uncommon",
  slot: "weapon",
  shopCategory: "ranged",
  statChanges: [
    { stat: "attackDamage", value: 15 },
    { stat: "movespeed", value: -10 }
  ],
  sprite: {
    sheet: "weapons/ranged_weapons/bow",
    frameIndex: 1
  },
  tags: ["daily-rotation", "two-handed", "ranged"]
};
export {
  HUNTING_BOW
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL3dlYXBvbnMvYm93cy9odW50aW5nLWJvdy50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiLyoqXG4gKiBIdW50aW5nIEJvdyAtIHVuY29tbW9uIHJhbmdlZFxuICovXG5cbmltcG9ydCB7IEl0ZW1EZWZpbml0aW9uIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgSFVOVElOR19CT1c6IEl0ZW1EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnaHVudGluZy1ib3cnLFxuICBuYW1lOiAnSHVudGluZyBCb3cnLFxuICBkZXNjcmlwdGlvbjogJ1VzZWQgdG8gdGFrZSBkb3duIGJpZyBnYW1lJyxcbiAgcmFyaXR5OiAndW5jb21tb24nLFxuICBzbG90OiAnd2VhcG9uJyxcblxuICBzaG9wQ2F0ZWdvcnk6ICdyYW5nZWQnLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ2F0dGFja0RhbWFnZScsIHZhbHVlOiAxNSB9LFxuICAgIHsgc3RhdDogJ21vdmVzcGVlZCcsIHZhbHVlOiAtMTAgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3ZWFwb25zL3JhbmdlZF93ZWFwb25zL2JvdycsXG4gICAgZnJhbWVJbmRleDogMSxcbiAgfSxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICd0d28taGFuZGVkJywgJ3JhbmdlZCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQU1PLE1BQU0sY0FBOEI7QUFBQSxFQUN6QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFFTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sZ0JBQWdCLE9BQU8sR0FBRztBQUFBLElBQ2xDLEVBQUUsTUFBTSxhQUFhLE9BQU8sSUFBSTtBQUFBLEVBQ2xDO0FBQUEsRUFDQSxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsTUFBTSxDQUFDLGtCQUFrQixjQUFjLFFBQVE7QUFDakQ7IiwKICAibmFtZXMiOiBbXQp9Cg==
